// import React from 'react'

// const Quiz = () => {
//   return (
//     <div>Quiz</div>
//   )
// }

// export default Quiz

// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from '../../context/authContext';
// import './Quiz.css'; // Import external CSS for modern styles

// const Quiz = () => {
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [timer, setTimer] = useState(30 * 60); // 30 minutes in seconds
//   const navigate = useNavigate();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const { currentUser } = useContext(AuthContext);
//   const [errorMessage, setErrorMessage] = useState(''); // State for error messages

//   useEffect(() => {
//     const fetchQuestions = async () => {
//       try {
//         const response = await axios.get('https://4a644ab9ea539e8c4b6dade527faf4a1.serveo.net/api/quiz/all');
//         setQuestions(response.data);
//       } catch (error) {
//         console.error('Error fetching quizzes:', error);
//       }
//     };
//     fetchQuestions();
//   }, []);

//   useEffect(() => {
//     if (timer > 0 && !isSubmitting) {
//       const intervalId = setInterval(() => {
//         setTimer((prevTime) => prevTime - 1);
//       }, 1000);
//       return () => clearInterval(intervalId);
//     } else if (timer === 0) {
//       handleSubmitQuiz();
//     }
//   }, [timer, isSubmitting]);

//   const handleOptionChange = (questionId, selectedOption) => {
//     setAnswers({ ...answers, [questionId]: selectedOption });
//   };
//   const handleSubmitQuiz = async (e) => {
//     e?.preventDefault();
//     setIsSubmitting(true);

//     const totalQuestions = questions.length;
//     const correctAnswers = questions.filter((q) => q.correctAnswer === answers[q._id]).length;
//     const percentage = (correctAnswers / totalQuestions) * 100;

//     const resultData = {
//         userId: currentUser?.portalID,
//         name: currentUser?.firstName,
//         department: currentUser?.deptName,
//         correctAnswers,
//         totalQuestions,
//         percentage
//     };

//     try {
//         const response = await axios.post('https://4a644ab9ea539e8c4b6dade527faf4a1.serveo.net/api/quiz/result', resultData);

//         if (response.status === 201) {
//             navigate('/result'); // Navigate to the result page on successful submission
//         } else if (response.status === 400) {
//             // Handle case where result already exists
//             setErrorMessage('Quiz result has already been submitted.');
//         }
//     } catch (error) {
//         console.error('Error submitting quiz result:', error);
//         setErrorMessage('Quiz result has already been submitted.');
//         // setErrorMessage('Failed to submit quiz result. Please try again.');
//         setIsSubmitting(false); // Allow the user to try again if submission fails
//     } finally {
//         setIsSubmitting(false); // Always allow the user to try again or handle the state
//     }
// };


//   const formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const remainingSeconds = seconds % 60;
//     return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
//   };

//   return (
//     <div className="quiz-container">
//       <h1 className="quiz-title">Quiz</h1>
//       <div className="timer">Time Remaining: {formatTime(timer)}</div>
//       <form onSubmit={handleSubmitQuiz} className="quiz-form">
//         {questions.map((question) => (
//           <div key={question._id} className="question">
//             <h3>{question.question}</h3>
//             {question.options.map((option) => (
//               <label key={option} className="option-label">
//                 <input
//                   type="radio"
//                   name={question._id}
//                   value={option}
//                   onChange={() => handleOptionChange(question._id, option)}
//                   required
//                 />
//                 {option}
//               </label>
//             ))}
//           </div>
//         ))}
//         {errorMessage && <p className="login-error">{errorMessage}</p>}
//         <button className="submit-quiz-button" type="submit" disabled={isSubmitting}>
//           Submit Quiz
//         </button>
//           {/* {setErrorMessage && <p>{setErrorMessage} </p>} */}
//       </form>
//     </div>
//   );
// };

// export default Quiz;

import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../context/authContext';
import './Quiz.css'; // Import external CSS for modern styles

const Quiz = () => {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [timer, setTimer] = useState(30 * 60); // 30 minutes in seconds
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState(''); // State for error messages

  const quizDuration = 9 * 60; // 30 minutes in seconds

  // Function to calculate the remaining time based on quiz start time
  const calculateRemainingTime = () => {
    const startTime = localStorage.getItem('quizStartTime');
    if (startTime) {
      const elapsedTime = Math.floor((Date.now() - parseInt(startTime)) / 1000);
      const remainingTime = quizDuration - elapsedTime;
      return remainingTime > 0 ? remainingTime : 0;
    }
    return quizDuration; // If no start time, default to full duration
  };

  // On component mount, load questions and set the timer
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.get('http://162.210.199.3:3001/api/quiz');
        setQuestions(response.data);
      } catch (error) {
        console.error('Error fetching quizzes:', error);
      }
    };
    fetchQuestions();

    // Check if the quiz has already started and calculate the remaining time
    const storedTime = calculateRemainingTime();
    setTimer(storedTime);

    // If no start time exists, set the start time
    if (!localStorage.getItem('quizStartTime')) {
      localStorage.setItem('quizStartTime', Date.now().toString());
    }
  }, []);

  // Timer countdown logic
  useEffect(() => {
    if (timer > 0 && !isSubmitting) {
      const intervalId = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
        localStorage.setItem('remainingTime', timer - 1); // Persist the remaining time in localStorage
      }, 1000);
      return () => clearInterval(intervalId);
    } else if (timer === 0) {
      handleSubmitQuiz();
    }
  }, [timer, isSubmitting]);

  const handleOptionChange = (questionId, selectedOption) => {
    setAnswers({ ...answers, [questionId]: selectedOption });
  };

  const handleSubmitQuiz = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);

    const totalQuestions = questions.length;
    const correctAnswers = questions.filter((q) => q.correctAnswer === answers[q._id]).length;
    const percentage = (correctAnswers / totalQuestions) * 100;
     // Proper string concatenation using template literals
  const name = `${currentUser?.title || ''} ${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim();

    const resultData = {
      userId: currentUser?.portalID,
      name: name,
      department: currentUser?.deptName,
      correctAnswers,
      totalQuestions,
      percentage
    };

    try {
      const response = await axios.post('http://162.210.199.3:3001/api/quiz/results', resultData);

      if (response.status === 201) {
        navigate('/result'); // Navigate to the result page on successful submission
        localStorage.removeItem('quizStartTime'); // Clear quiz start time
      } else if (response.status === 400) {
        // Handle case where result already exists
        setErrorMessage('Quiz result has already been submitted.');
      }
    } catch (error) {
      console.error('Error submitting quiz result:', error);
      setErrorMessage('Quiz result has already been submitted.');
    } finally {
      setIsSubmitting(false); // Always allow the user to try again or handle the state
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <div className="quiz-container">
      <h1 className="quiz-title">Questions</h1>
      <div className="timer">Time Remaining: {formatTime(timer)}</div>
      <form onSubmit={handleSubmitQuiz} className="quiz-form">
        {questions.map((question) => (
          <div key={question._id} className="question">
            <h3>{question.question}</h3>
            {question.options.map((option) => (
              <label key={option} className="option-label">
                <input
                  type="radio"
                  name={question._id}
                  value={option}
                  onChange={() => handleOptionChange(question._id, option)}
                  required
                />
                {option}
              </label>
            ))}
          </div>
        ))}
        {errorMessage && <p className="login-error">{errorMessage}</p>}
        <button className="submit-quiz-button" type="submit" disabled={isSubmitting}>
          Submit Quiz
        </button>
      </form>
    </div>
  );
};

export default Quiz;

  // const handleSubmitQuiz = async (e) => {
  //   e?.preventDefault();
  //   setIsSubmitting(true);

  //   const totalQuestions = questions.length;
  //   const correctAnswers = questions.filter((q) => q.correctAnswer === answers[q._id]).length;
  //   const percentage = (correctAnswers / totalQuestions) * 100;

  //   const resultData = {
  //     userId: currentUser?.portalID,
  //     name: currentUser?.firstName,
  //     department: currentUser?.deptName,
  //     correctAnswers,
  //     totalQuestions,
  //     percentage
  //   };

  //   try {
  //     await axios.post('https://dd139e3593c018168e2e180ed7c923a3.serveo.net/api/quiz/result', resultData);
  //     navigate('/result');
  //   } catch (error) {
  //     console.error('Error submitting quiz result:', error);
  //     setIsSubmitting(false);
  //   }
  // };
